import _asyncToGenerator from "/codebuild/output/src1641/src/s3/01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/codebuild/output/src1641/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/codebuild/output/src1641/src/s3/01/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.date.to-string.js";
var polyfills = {
  fetch: globalThis.fetch ? globalThis.fetch.bind(globalThis) : undefined,
  SubtleCrypto: globalThis.crypto ? globalThis.crypto.subtle : undefined,
  EventSource: globalThis.EventSource
};
export function getPolyfills() {
  return polyfills;
}
function hashFnv32a(str) {
  var hval = 0x811c9dc5;
  var l = str.length;
  for (var i = 0; i < l; i++) {
    hval ^= str.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }
  return hval >>> 0;
}
export function hash(seed, value, version) {
  // New unbiased hashing algorithm
  if (version === 2) {
    return hashFnv32a(hashFnv32a(seed + value) + "") % 10000 / 10000;
  }
  // Original biased hashing algorithm (keep for backwards compatibility)
  if (version === 1) {
    return hashFnv32a(value + seed) % 1000 / 1000;
  }

  // Unknown hash version
  return null;
}
export function getEqualWeights(n) {
  if (n <= 0) return [];
  return new Array(n).fill(1 / n);
}
export function inRange(n, range) {
  return n >= range[0] && n < range[1];
}
export function inNamespace(hashValue, namespace) {
  var n = hash("__" + namespace[0], hashValue, 1);
  if (n === null) return false;
  return n >= namespace[1] && n < namespace[2];
}
export function chooseVariation(n, ranges) {
  for (var i = 0; i < ranges.length; i++) {
    if (inRange(n, ranges[i])) {
      return i;
    }
  }
  return -1;
}
export function getUrlRegExp(regexString) {
  try {
    var escaped = regexString.replace(/([^\\])\//g, "$1\\/");
    return new RegExp(escaped);
  } catch (e) {
    console.error(e);
    return undefined;
  }
}
export function isURLTargeted(url, targets) {
  if (!targets.length) return false;
  var hasIncludeRules = false;
  var isIncluded = false;
  for (var i = 0; i < targets.length; i++) {
    var match = _evalURLTarget(url, targets[i].type, targets[i].pattern);
    if (targets[i].include === false) {
      if (match) return false;
    } else {
      hasIncludeRules = true;
      if (match) isIncluded = true;
    }
  }
  return isIncluded || !hasIncludeRules;
}
function _evalSimpleUrlPart(actual, pattern, isPath) {
  try {
    // Escape special regex characters and change wildcard `_____` to `.*`
    var escaped = pattern.replace(/[*.+?^${}()|[\]\\]/g, "\\$&").replace(/_____/g, ".*");
    if (isPath) {
      // When matching pathname, make leading/trailing slashes optional
      escaped = "\\/?" + escaped.replace(/(^\/|\/$)/g, "") + "\\/?";
    }
    var regex = new RegExp("^" + escaped + "$", "i");
    return regex.test(actual);
  } catch (e) {
    return false;
  }
}
function _evalSimpleUrlTarget(actual, pattern) {
  try {
    // If a protocol is missing, but a host is specified, add `https://` to the front
    // Use "_____" as the wildcard since `*` is not a valid hostname in some browsers
    var expected = new URL(pattern.replace(/^([^:/?]*)\./i, "https://$1.").replace(/\*/g, "_____"), "https://_____");

    // Compare each part of the URL separately
    var comps = [[actual.host, expected.host, false], [actual.pathname, expected.pathname, true]];
    // We only want to compare hashes if it's explicitly being targeted
    if (expected.hash) {
      comps.push([actual.hash, expected.hash, false]);
    }
    expected.searchParams.forEach(function (v, k) {
      comps.push([actual.searchParams.get(k) || "", v, false]);
    });

    // If any comparisons fail, the whole thing fails
    return !comps.some(function (data) {
      return !_evalSimpleUrlPart(data[0], data[1], data[2]);
    });
  } catch (e) {
    return false;
  }
}
function _evalURLTarget(url, type, pattern) {
  try {
    var parsed = new URL(url, "https://_");
    if (type === "regex") {
      var regex = getUrlRegExp(pattern);
      if (!regex) return false;
      return regex.test(parsed.href) || regex.test(parsed.href.substring(parsed.origin.length));
    } else if (type === "simple") {
      return _evalSimpleUrlTarget(parsed, pattern);
    }
    return false;
  } catch (e) {
    return false;
  }
}
export function getBucketRanges(numVariations, coverage, weights) {
  coverage = coverage === undefined ? 1 : coverage;

  // Make sure coverage is within bounds
  if (coverage < 0) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Experiment.coverage must be greater than or equal to 0");
    }
    coverage = 0;
  } else if (coverage > 1) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Experiment.coverage must be less than or equal to 1");
    }
    coverage = 1;
  }

  // Default to equal weights if missing or invalid
  var equal = getEqualWeights(numVariations);
  weights = weights || equal;
  if (weights.length !== numVariations) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Experiment.weights array must be the same length as Experiment.variations");
    }
    weights = equal;
  }

  // If weights don't add up to 1 (or close to it), default to equal weights
  var totalWeight = weights.reduce(function (w, sum) {
    return sum + w;
  }, 0);
  if (totalWeight < 0.99 || totalWeight > 1.01) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Experiment.weights must add up to 1");
    }
    weights = equal;
  }

  // Covert weights to ranges
  var cumulative = 0;
  return weights.map(function (w) {
    var start = cumulative;
    cumulative += w;
    return [start, start + coverage * w];
  });
}
export function getQueryStringOverride(id, url, numVariations) {
  if (!url) {
    return null;
  }
  var search = url.split("?")[1];
  if (!search) {
    return null;
  }
  var match = search.replace(/#.*/, "") // Get rid of anchor
  .split("&") // Split into key/value pairs
  .map(function (kv) {
    return kv.split("=", 2);
  }).filter(function (_ref) {
    var _ref3 = _slicedToArray(_ref, 1),
      k = _ref3[0];
    return k === id;
  }) // Look for key that matches the experiment id
  .map(function (_ref2) {
    var _ref4 = _slicedToArray(_ref2, 2),
      v = _ref4[1];
    return parseInt(v);
  }); // Parse the value into an integer

  if (match.length > 0 && match[0] >= 0 && match[0] < numVariations) return match[0];
  return null;
}
export function isIncluded(include) {
  try {
    return include();
  } catch (e) {
    console.error(e);
    return false;
  }
}
var base64ToBuf = function base64ToBuf(b) {
  return Uint8Array.from(atob(b), function (c) {
    return c.charCodeAt(0);
  });
};
export function decrypt(_x, _x2, _x3) {
  return _decrypt.apply(this, arguments);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _decrypt() {
  _decrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(encryptedString, decryptionKey, subtle) {
    var key, _encryptedString$spli, _encryptedString$spli2, iv, cipherText, plainTextBuffer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          decryptionKey = decryptionKey || "";
          subtle = subtle || globalThis.crypto && globalThis.crypto.subtle || polyfills.SubtleCrypto;
          if (subtle) {
            _context.next = 4;
            break;
          }
          throw new Error("No SubtleCrypto implementation found");
        case 4:
          _context.prev = 4;
          _context.next = 7;
          return subtle.importKey("raw", base64ToBuf(decryptionKey), {
            name: "AES-CBC",
            length: 128
          }, true, ["encrypt", "decrypt"]);
        case 7:
          key = _context.sent;
          _encryptedString$spli = encryptedString.split("."), _encryptedString$spli2 = _slicedToArray(_encryptedString$spli, 2), iv = _encryptedString$spli2[0], cipherText = _encryptedString$spli2[1];
          _context.next = 11;
          return subtle.decrypt({
            name: "AES-CBC",
            iv: base64ToBuf(iv)
          }, key, base64ToBuf(cipherText));
        case 11:
          plainTextBuffer = _context.sent;
          return _context.abrupt("return", new TextDecoder().decode(plainTextBuffer));
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](4);
          throw new Error("Failed to decrypt");
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 15]]);
  }));
  return _decrypt.apply(this, arguments);
}
export function toString(input) {
  if (typeof input === "string") return input;
  return JSON.stringify(input);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function paddedVersionString(input) {
  if (typeof input === "number") {
    input = input + "";
  }
  if (!input || typeof input !== "string") {
    input = "0";
  }
  // Remove build info and leading `v` if any
  // Split version into parts (both core version numbers and pre-release tags)
  // "v1.2.3-rc.1+build123" -> ["1","2","3","rc","1"]
  var parts = input.replace(/(^v|\+.*$)/g, "").split(/[-.]/);

  // If it's SemVer without a pre-release, add `~` to the end
  // ["1","0","0"] -> ["1","0","0","~"]
  // "~" is the largest ASCII character, so this will make "1.0.0" greater than "1.0.0-beta" for example
  if (parts.length === 3) {
    parts.push("~");
  }

  // Left pad each numeric part with spaces so string comparisons will work ("9">"10", but " 9"<"10")
  // Then, join back together into a single string
  return parts.map(function (v) {
    return v.match(/^[0-9]+$/) ? v.padStart(5, " ") : v;
  }).join("-");
}
export function loadSDKVersion() {
  var version;
  try {
    // @ts-expect-error right-hand value to be replaced by build with string literal
    version = "1.3.1";
  } catch (e) {
    version = "";
  }
  return version;
}
export function mergeQueryStrings(oldUrl, newUrl) {
  var currUrl;
  var redirectUrl;
  try {
    currUrl = new URL(oldUrl);
    redirectUrl = new URL(newUrl);
  } catch (e) {
    console.error("Unable to merge query strings: ".concat(e));
    return newUrl;
  }
  currUrl.searchParams.forEach(function (value, key) {
    // skip  if search param already exists in redirectUrl
    if (redirectUrl.searchParams.has(key)) {
      return;
    }
    redirectUrl.searchParams.set(key, value);
  });
  return redirectUrl.toString();
}
function isObj(x) {
  return typeof x === "object" && x !== null;
}
export function getAutoExperimentChangeType(exp) {
  if (exp.urlPatterns && exp.variations.some(function (variation) {
    return isObj(variation) && "urlRedirect" in variation;
  })) {
    return "redirect";
  } else if (exp.variations.some(function (variation) {
    return isObj(variation) && (variation.domMutations || "js" in variation || "css" in variation);
  })) {
    return "visual";
  }
  return "unknown";
}

// Guarantee the promise always resolves within {timeout} ms
// Resolved value will be `null` when there's an error or it takes too long
// Note: The promise will continue running in the background, even if the timeout is hit
export function promiseTimeout(_x4, _x5) {
  return _promiseTimeout.apply(this, arguments);
}
function _promiseTimeout() {
  _promiseTimeout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(promise, timeout) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", new Promise(function (resolve) {
            var resolved = false;
            var timer;
            var finish = function finish(data) {
              if (resolved) return;
              resolved = true;
              timer && clearTimeout(timer);
              resolve(data || null);
            };
            if (timeout) {
              timer = setTimeout(function () {
                return finish();
              }, timeout);
            }
            promise.then(function (data) {
              return finish(data);
            })["catch"](function () {
              return finish();
            });
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _promiseTimeout.apply(this, arguments);
}